<template>
    <div class="roothome">

        <div class="wrapper">
            <!-- ################    Top Menu Bar    ################# -->
            <div align="center" class="head0">
                <div class="head1">
                    <div style="width: 100%; text-align: left; height: 5vh; display: flex">
                        <img src="/static/imgs/ic_back_b.png" alt="menu" class="im_menu2" style="padding-left: 10%;" @click="goToHome()" onMouseOver="this.style.cursor='pointer'">
                    </div>
                </div>
                <div class="head2">
                    <!-- ################    Title    ################# -->
                    <!--<router-link :to="{ params: { stabs: estabs_full, categs: cats_full}, name: 'Home'}" style="height: 100%; display: flex; align-items: center; justify-content: center;">-->
                    <img @click="goToBack()" src="/static/imgs/advicep_horizontal.png" alt="logo advice" class="im40_2">
                    <!--</router-link>-->
                    <br>
                </div>
                <div  class="head3">
                    <!--<div style="display: flex; height: 35%; width: 100%; align-items: center; justify-content: center;">-->
                    <!--<div class="bar_idiomas">-->
                    <!--<img v-if="user.idioma==0" src="/static/imgs/ic_b_pt.jpg" alt="barra idiomas" style="height: 70%;">-->
                    <!--<img v-if="user.idioma==1" src="/static/imgs/ic_b_en.jpg" alt="barra idiomas" style="height: 70%;">-->
                    <!--<img v-if="user.idioma==2" src="/static/imgs/ic_b_es.jpg" alt="barra idiomas" style="height: 70%;">-->
                    <!--<span style="font-size: 2vh; color: black; margin-right: 7%;"> {{ getIdioma(user.idioma) }} </span>-->
                    <!--<select id="changeIdiomaSelect" @change="changeIdiomaSelector($event)" v-model="user.idioma" style="border:0px; outline:0px; border: none; scroll-behavior: smooth; background-color: white; -webkit-appearance:none; font-size: 2vh; position: absolute; opacity: 0; width: 100%;">-->
                    <!--<option value="0"> {{ getIdioma(0) }}&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                    <!--<option value="1"> {{ getIdioma(1) }}&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                    <!--<option value="2"> {{ getIdioma(2) }}&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                    <!--</select>-->
                    <!--</div>-->
                    <!--</div>-->
                    <span class="tx_title_guia">{{getInterText(inter_ind.seu_guia_turistico)}}</span>
                    <div class="im_id_container">
                        <img class="im_id" v-if="user.idioma==0" src="/static/imgs/ic_pt2.png"/>
                        <img class="im_id" v-if="user.idioma!=0" src="/static/imgs/ic_pt1.png" @click="changeIdioma(0)"/>
                        <img class="im_id" v-if="user.idioma==1" src="/static/imgs/ic_en2.png"/>
                        <img class="im_id" v-if="user.idioma!=1" src="/static/imgs/ic_en1.png" @click="changeIdioma(1)"/>
                        <img class="im_id" v-if="user.idioma==2" src="/static/imgs/ic_es2.png"/>
                        <img class="im_id" v-if="user.idioma!=2" src="/static/imgs/ic_es1.png" @click="changeIdioma(2)"/>
                    </div>

                    <!--<div style="display: flex; height: 40%; margin-left: 10%; margin-right: 10%;">-->
                    <!--<a target="_blank" href="https://www.youtube.com/channel/UCbWLHHK-IIHT6BZRWU0n5eg"><img src="/static/imgs/ic_youtube2.png" alt="youtube" class="im_social"></a>-->
                    <!--<a target="_blank" href="https://www.facebook.com/adviceparaiba/"><img src="/static/imgs/ic_face2.png" alt="facebook" class="im_social"></a>-->
                    <!--<a target="_blank" href="https://www.instagram.com/adviceparaiba/"><img src="/static/imgs/ic_instagram2.png" alt="instagram" class="im_social"></a>-->
                    <!--<a target="_blank" href="https://twitter.com/AdviceParaiba"><img src="/static/imgs/ic_twitter2.png" alt="twitter" class="im_social"></a>-->
                    <!--</div>-->
                </div>
                <div  class="head4">
                    <div v-if="!user.sucess" style="display: flex; flex-direction: row; align-items: center; height: 100%;">
                        <div style="display: flex; height: 100%; min-height: 100%; align-items: flex-end;">
                            <a href="/registerUser" >
                                <span class="tx_login2" >{{ getInterText(inter_ind.cadastre) }} </span>
                            </a>
                        </div>

                        <div style="display: flex; flex-direction: column; align-items: center;">
                            <img @click="setShowLogin(true)" onMouseOver="this.style.cursor='pointer'" src="/static/imgs/ic_profile2.png" alt="profile" class="im_profile" style="height: 25%; margin-right: 0; margin-left: 0; margin-bottom: -15%;">

                            <span class="tx_login" style="margin-bottom: 1%; color: var(--gray-menu)" @click="setShowLogin(true)" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.entrar) }}</span>
                        </div>

                    </div>
                    <div v-else @click="showPopEscritorio()">
                        <div v-if='user.foto === ""' class="im_profile" style="text-align: center; padding-top: 1.2vh; background-color: var(--bg-blue)">
                            <span class="tx_initials" >{{ getInitials(user) }}</span>
                        </div>
                        <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile">
                        <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im_profile">
                        <br>
                        <span class="tx_login5" >{{ getFirstAndLastWords(user.nome) }}</span>
                    </div>
                    <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                        <div class="arrow_top"></div>
                        <!--<span class="tx_login" >{{ user.nome }}</span>-->
                        <div style="display: flex; flex-direction: column; height: 15vh; justify-content: space-evenly;">
                            <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('MinhaPagina')">{{ getInterText(inter_ind.minha_conta) }}</span>
                            <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('EditUser')">{{ getInterText(inter_ind.configuracoes) }}</span>
                            <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ################    panorama e busca    ################# -->
            <div class="title4">

                <!--Barra de cabecalho com imagem-->
                <img src="/static/imgs/bg_picao2.jpg" style="width: 100%; object-fit: cover; margin-top: -5vh; object-position: top;"/>

            <div style="display: flex; justify-content: flex-end; align-items: flex-end; flex-direction: row; margin-right: 1vw; margin-top: 2vw;">
                <div v-if="share" style="display: flex; margin-right: 2vw; justify-content: space-between; width: 17vw;">
                    <img @click="goShare(0)" src="/static/imgs/ic_share_whats_3d.png" class="small-share-img">
                    <img @click="goShare(1)" src="/static/imgs/ic_share_face_3d.png"  class="small-share-img">
                    <img @click="goShare(2)" src="/static/imgs/ic_share_link_3d.png"  class="small-share-img">
                </div>
                <img v-if="share" @click="showShare()" src="/static/imgs/ic_share_blue.png" alt="Share" style="height: 5vw; object-fit: contain; cursor: pointer; margin-left: 5px;"/>
                <img v-else @click="showShare()" src="/static/imgs/ic_share.png" alt="Share" style="height: 5vw; object-fit: contain; cursor: pointer; margin-left: 5px;"/>
            </div>

                <div class="div_expedicao">
                    <div class="ct_arrow">
                        <img class="bt_arrow1" src="/static/imgs/ic_back_b.png" @click="changeTab(-1)"/>
                        <span class="tx_title_tabua">{{ getMes(tabuas[currTab].mes) }} {{ tabuas[currTab].ano }}</span>
                        <img class="bt_arrow2" src="/static/imgs/ic_back_b.png" @click="changeTab(1)"/>
                    </div>
                    <span style="margin-bottom: 0vh; font-size: 3vh"> João Pessoa / Porto de Cabedelo</span>
                    <!--<img class="im_tabua" :src="tb_img_base + tabuas[currTab].ano + '_' + tabuas[currTab].mes +'.jpg'" style="height: 100%; width: 80%; object-fit: contain;"/>-->
                </div>

                <div class="div_expedicao_in">
                    <img class="im_tabua" :src="tb_img_base + tabuas[currTab].ano + '_' + tabuas[currTab].mes +'.jpg'" />
                </div>
            </div>
        </div>


        <div class="div_login_m" v-if="showLogin" >
            <div class="parts_m">
                <div style="display: flex; justify-content: flex-end; width: 100%; margin-right: -45vw;" @click="setShowLogin(false)">
                    <img src="/static/imgs/bt_fechar_w.png" class="im_close_w" onMouseOver="this.style.cursor='pointer'">
                </div>

                <div style="text-align: center; margin-top: 5vh;">
                    <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="height: 8vh">
                </div>


                <!--<div class="div_face_w" style="margin-top: 10vh;" @click="externalLoginFace_checkLoginState()">-->
                <!--<div class="div_faceim">-->
                <!--<img src="/static/imgs/ic_face_blue.png" alt="facebook" class="im_face">-->
                <!--</div>-->

                <!--<div class="div_facetx">-->
                <!--<span class="tx_face_m"> {{ getInterText(inter_ind.entre_face) }} </span>-->
                <!--</div>-->
                <!--</div>-->


                <div class="div_face_w" style="margin-top: 9vh; margin-bottom: 4vh" @click="externalLoginGoogle_startApp()">
                    <!--<div class="div_face_w" style="margin-top: 1vh; margin-bottom: 5vh" @click="externalLoginGoogle_startApp()">-->
                    <div class="div_faceim">
                        <img src="/static/imgs/ic_google.png" alt="facebook" class="im_face">
                    </div>

                    <div class="div_facetx">
                        <span class="tx_face_m unselectable"> {{ getInterText(inter_ind.entre_google) }} </span>
                    </div>
                </div>





                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(1, true)" v-if="!editing[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>
                    <div class="hr_w" @click="clickInput(1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[1].status"/>
                    <span class="tx_nome_w" @click="clickInput(1, false)" v-if="editing[1].status">E-mail</span>
                    <input id="emailid" class="input_name_w" type="text" v-model="editing[1].texto" v-if="editing[1].status" tabindex="3"/>
                    <span v-if="!checkEmail(editing[1].texto) && editing[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(0, true)" v-if="!editing[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>
                    <div class="hr_w" @click="clickInput(0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[0].status"/>
                    <span class="tx_nome_w" @click="clickInput(0, false)" v-if="editing[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <input id="nameid" class="input_name_w" type="password" v-model="editing[0].texto" v-if="editing[0].status" tabindex="4"/>
                    <span v-if="!checkPass(editing[0].texto) && editing[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada) }}</span>
                </div>

                <div class="div_check" style="margin-top: 4vh;">
                    <div class="div_check_in" @click="changeCheckState(0)">
                        <span v-if="valid.enterAuto" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check" style="flex-grow: 1">{{ getInterText(inter_ind.entrar_auto) }}</span>
                    <span class="tx_check" style="cursor: pointer;">{{ getInterText(inter_ind.esqueceu_senha) }}</span>
                </div>

                <span v-if="senhaErrada" class="error_msg"> {{ getInterText(inter_ind.senha_errada) }} </span>
                <div style="text-align: center;">
                    <span v-if="userNaoCadastrado" class="error_msg"> {{ getInterText(inter_ind.usuario_nao_cadastrado) }}</span>
                </div>


                <img v-if="loading.user" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                <div style="display: flex; flex-direction: row; margin-top: 10vh">
                    <div class="div_botao_login" style="margin-right: 2vw; background-color: white;" @click="tryLogin()" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                        <span class="tx_continuar_w unselectable" style="color: var(--bg-blue);"> {{ getInterText(inter_ind.entrar) }} </span>

                    </div>
                    <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat}, name: 'registerUser'}">
                        <div class="div_botao_login">
                            <span class="tx_continuar_w unselectable" style="font-weight: normal;"> {{ getInterText(inter_ind.cadastre) }} </span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

        <filter id="colorize" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.18
                 0 0 0 0 0.24
                 0 0 0 0 0.31
                 0 0 0 1 0"/>
        </filter>

        <div class="overlay" @click="changeSideBar()"></div>

    </div>
</template>

<script>
    import axios from 'axios'
    import { advMixin } from '../scripts/advMixin'

    export default {
        mixins: [advMixin],
        name: 'dTabua',
        data () {
            return {
                name: 'dTabua',
                tb_img_base: '/static/tabua/tb_d_',
                share: false,
                currTab: 1,
                tabuas: [
                    {
                        ano: 2024,
                        mes: 1
                    },
                    {
                        ano: 2024,
                        mes: 2
                    },
                    {
                        ano: 2024,
                        mes: 3
                    },
                    {
                        ano: 2024,
                        mes: 4
                    },
                    {
                        ano: 2024,
                        mes: 5
                    },
                    {
                      ano: 2024,
                      mes: 6
                    },
                    {
                      ano: 2024,
                      mes: 7
                    },
                    {
                      ano: 2024,
                      mes: 8
                    },
                    {
                      ano: 2024,
                      mes: 9
                    }
                ]
            }
        },
        methods: {
            shuffle(array) {
                var tmp, current, top = array.length;
                if(top) while(--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }
                return array;
            },

            adjustCaracterEncoding() {
                var i;
                var vm = this;
                for (i=0 ; i<vm.estabs_full.length ; i++) {
                    try {
                        vm.estabs_full[i].nome = decodeURIComponent(escape(vm.estabs_full[i].nome));
                    } catch (e) {
                        vm.estabs_full[i].nome = unescape(vm.estabs_full[i].nome);
                    }
                    try {
                        vm.estabs_full[i].horario = decodeURIComponent(escape(vm.estabs_full[i].horario));
                    } catch (e) {
                        vm.estabs_full[i].horario = unescape(vm.estabs_full[i].horario);
                    }
                    try {
                        vm.estabs_full[i].responsavel = decodeURIComponent(escape(vm.estabs_full[i].responsavel));
                    } catch (e) {
                        vm.estabs_full[i].responsavel = unescape(vm.estabs_full[i].responsavel);
                    }
                    try {
                        vm.estabs_full[i].rua_num = decodeURIComponent(escape(vm.estabs_full[i].rua_num));
                    } catch (e) {
                        vm.estabs_full[i].rua_num = unescape(vm.estabs_full[i].rua_num);
                    }
                    try {
                        vm.estabs_full[i].bairro = decodeURIComponent(escape(vm.estabs_full[i].bairro));
                    } catch (e) {
                        vm.estabs_full[i].bairro = unescape(vm.estabs_full[i].bairro);
                    }
                    try {
                        vm.estabs_full[i].cidade = decodeURIComponent(escape(vm.estabs_full[i].cidade));
                    } catch (e) {
                        vm.estabs_full[i].cidade = unescape(vm.estabs_full[i].cidade);
                    }
                }
            },
            getEstabsCats() {
                console.log('Entrei no getEstabsCats()');

                var url1 = this.baseUrlApi + 'estabelecimentos';
                var url2 = this.baseUrlApi + 'categorias';

                var vm = this;
                vm.loading.cats = true;
                vm.loading.estabs = true;

                axios.all([
                    axios.get(url1),
                    axios.get(url2),
                ])
                    .then(axios.spread(function(r1, r2) {
                        vm.estabs_full = r1.data;
                        vm.cats_full = r2.data;

                        //vm.dataj = Object.assign({}, vm.dataj, { estabs_full: r1.data, cats_full: r2.data });
                        //vm.$set(vm, 'dataj', { estabs_full: r1.data, cats_full: r2.data });

                        vm.adjustCaracterEncoding();

                        console.log('Estabelecimentos:');
                        console.log(vm.estabs_full);
                        console.log('Categorias:');
                        console.log(vm.cats_full);
                        vm.loading.cats = false;
                        vm.loading.estabs = false;
                        vm.atualizaParametros();
                    }))
                    .catch(function(error) {
                        vm.loading.cats = false;
                        vm.loading.estabs = false;
                        console.log('Error Catch' + error);
                    });
            },
            getEstabsSearch() {
                console.log('getEstabsSearch ' + this.search_text);

                this.estabs_search = [];

                this.cats = [
                    {
                        nome: this.inter_pt[this.inter_ind.resultado_busca],
                        nomeEn: this.inter_en[this.inter_ind.resultado_busca],
                        nomeEs: this.inter_es[this.inter_ind.resultado_busca],
                        id: -1
                    }
                ];




                if (this.search_text.length<3) {
                    console.log('getEstabsSearch::nao vou buscar');

                    if (this.search_text.length==0) {
                        this.cats = this.cats_full;
                    }
                    return ;
                }

                var search_text2 = this.search_text.toLowerCase();
                var i;
                for (i=0 ; i<this.estabs_full.length ; i++) {
                    var estab = this.estabs_full[i];

                    if (estab.nome.toLowerCase().indexOf(search_text2)>=0 ||
                        estab.bairro.toLowerCase().indexOf(search_text2)>=0 ||
                        estab.descricao2.toLowerCase().indexOf(search_text2)>=0) {
                        this.estabs_search.push(estab);
                        console.log('search: ' + estab.nome);
                    }
                    else {
                        var j;
                        for (j=0 ; j < estab.tbCategoriaEstabelecimentos.length ; j++) {
                            var catt = estab.tbCategoriaEstabelecimentos[j];
                            if (catt.nome.toLowerCase().indexOf(search_text2)>=0) {
                                this.estabs_search.push(estab);
                                console.log('search: ' + estab.nome);
                                break;
                            }
                        }
                    }
                }
            },
            getEstabs(idCat) {
                console.log('getEstabs ' + idCat);
                var vm = this;

                var estabs = [];

                if (idCat==-1) {
                    estabs = this.estabs_search;
                }
                else {
                    var i;
                    for (i = 0; i < vm.estabs_full.length; i++) {
                        var estab = vm.estabs_full[i];

                        var j;
                        for (j = 0; j < estab.tbCategoriaEstabelecimentos.length; j++) {
                            var cat = estab.tbCategoriaEstabelecimentos[j];
                            if (cat.id == idCat && (this.cityIndex == 0 || estab.cidade == this.city_full[this.cityIndex].nome) && estab.ativo && estab.aprovado) {
                                estabs.push(estab);
                            }
                        }
                    }
                }

                this.estabs = estabs;

                return estabs;
            },
            hasEstabs(idCat) {
                console.log('hasEstabs ' + idCat);
                var vm = this;

                var estabs = [];

                if (idCat==-1) {
                    estabs = this.estabs_search;
                }
                else {
                    var i;
                    for (i = 0; i < vm.estabs_full.length; i++) {
                        var estab = vm.estabs_full[i];

                        var j;
                        for (j = 0; j < estab.tbCategoriaEstabelecimentos.length; j++) {
                            var cat = estab.tbCategoriaEstabelecimentos[j];
                            if (cat.id == idCat && (this.cityIndex == 0 || estab.cidade == this.city_full[this.cityIndex].nome) && estab.ativo && estab.aprovado) {
                                return true;
                            }
                        }
                    }
                }

                return false;
            },
            atualizaEstabs(idCatAtual) {
                console.log('atualizaEstabs id: ' + idCatAtual);
                var vm = this;

                if (idCatAtual==0) {
                    vm.cats = vm.cats_full;
                    console.log('cats:');
                    console.log(vm.cats);
                }
                else {
                    // vm.estabs = [];
                    vm.cats = [];

                    // Ta nesse for separado para que mesmo se nao tiver nenhum estabelecimento na categoria selecionada ele altere o tituloCat.
                    var i;
                    for (i = 0; i < vm.cats_full.length; i++) {
                        var cat = vm.cats_full[i];
                        if (cat.id == idCatAtual) {
                            vm.tituloCat = cat.nome;
                            vm.corCat = cat.cor;
                            vm.idCat = cat.id;
                            vm.cats.push(cat);
                            break;
                        }
                    }
                }


                $('#sidebar').removeClass('active');
                $('.overlay').fadeOut();
                $('#icmenu').removeClass('open');
                // $('#div_pat_s').fadeOut(0);
            },
            atualizaParametros() {
                console.log('atualizaParametros');
                console.log(this.$route.query);

                if (this.$route.query.idCat == null) {
                    // this.tituloCat = "Destaques";
                    this.idCat = 0;
                    // this.corCat = "#96989b";
                    console.log('id eh nulo');
                } else {
                    this.idCat = this.$route.query.idCat;
                    console.log('id eh valido ' + this.idCat);
                }

                this.getCities();

                this.atualizaEstabs(this.idCat);
            },

            trimAll(str){
                return str.replace(/\s/g,'');
            },

            changeTab(i) {
                console.log('changeTab::', this.currTab)
                if (i > 0) {
                    if (this.currTab < this.tabuas.length - 1) {
                        this.currTab++;
                    }
                } else {
                    if (this.currTab > 0) {
                        this.currTab--;
                    }
                }
                console.log('changeTab::', this.currTab)
            },
            getMes(mes) {
                switch (mes) {
                    case 1: return 'JANEIRO';
                    case 2: return 'FEVEREIRO';
                    case 3: return 'MARÇO';
                    case 4: return 'ABRIL';
                    case 5: return 'MAIO';
                    case 6: return 'JUNHO';
                    case 7: return 'JULHO';
                    case 8: return 'AGOSTO';
                    case 9: return 'SETEMBRO';
                    case 10: return 'OUTUBRO';
                    case 11: return 'NOVEMBRO';
                    case 12: return 'DEZEMBRO';
                }
            }
        },
        created() {
            console.log('created!!');

            let d = new Date()
            this.currTab = d.getMonth();

            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                if (this.$route.params.idCat != null) {
                    this.idCat = this.$route.params.idCat;
                }
            }

            console.log('Terminei o created!!');
        },
        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },
        mounted() {
            console.log('mounted!!');


            console.log('Terminei o mounted!!');
        },

    }

</script>


<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/advDesk.css" scoped/>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .roothome {
        /*background-color: #f0f0f0;*/
        /*background-color: var(--main-bg-color);*/
        background-color: white;
        overflow-y: scroll;
    }
    .roothome::-webkit-scrollbar {
        /* This is the magic bit */
        display: none;
    }

    .im_social {
        display: inline-block;
        /*width: 35px;*/
        /*width: 2.6vw;*/
        height: 90%;
        width: 100%;
        margin-top: 0.2vh;
        /*padding: 3px;*/
        object-fit: scale-down;
        /*padding: 0.1vw;*/
        vertical-align: middle;
    }
    .bar_idiomas {
        display: flex;
        vertical-align: middle;
        /*background-color: red;*/
        /*padding-left: 1vw;*/
        align-items: center;
        justify-content: space-evenly;
        background-image: url('/static/imgs/ic_barra_idiomas_w.png');
        /*background-size: auto 100%;*/
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 3.5vh;
    }

    .wrapper {
        display: flex;
        justify-content: center;
    }

    .title4 {
        text-align: center;

        margin-top: var(--top-bar-heigth_desk);
    }

    .div_face_w {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 2vh;
        width: 100%;
        display: flex;
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
    }

    .div_face_w {
        display: flex;
        flex-direction: row;
        align-items: center;

        display: flex;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;

        width: 90%;
        padding: 1.5vw;
        background: white;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        cursor: pointer;
    }

    .div_faceim {
        /*background: pink;*/
        display: flex;
        justify-content: center;
        flex-basis: 0;
        flex-grow: 1;
    }

    .im_face {
        /*background: red;*/
        display: flex;
        width: 3vh;
        height: 3vh;
        -webkit-filter: brightness(150%);
        filter: brightness(150%);
    }

    .div_facetx {
        /*background: brown;*/
        display: flex;
        justify-content: center;
        flex-grow: 1;
    }



    div_botao_t {
        display: flex;
        align-items: center;
        padding: 2vh;
        width: 80%;
        display: flex;
        color: white;
        background: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
        margin-top: 5vh;
    }

    .im_loading_up {
        width: 50px;
        height: 50px;
    }

    select#sel_cats {
        margin-left: 2vw;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;       /* Remove default arrow */
        outline: none;
        background-color: var(--bg-blue-grad1);
        /*background-color: red;*/
        display: flex;
        align-items: center;
        justify-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border: none;
        padding-left: 2%;
        /*font-size: 12pt;*/
        font-size: 2vh;
    }

    /****************** Login window *****************/
    .div_login_m {
        /*background: rgba(1, 0, 0, .7);*/
        /*background: blue;*/
        flex-direction: column;
        display: flex;
        justify-content: center;
        position: fixed;
        align-items: center;
        top: 0;
        width: 100vw;
        height: 100vh;
        overflow-x: auto;
        overflow-y: auto;
        z-index: 1000;
    }

    .parts_m {
        background-color: blue;
        background-image: url('/static/imgs/bg_login.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        /*background: red;*/
        /*box-shadow: 5px 5px 5px black;*/
        width: 100vw;
        height: 100vh;
        /*height: max-content;*/
        display: flex;
        padding: 8vw;
        padding-top: 1vw;
        align-items: center;
        overflow-y: auto;
        flex-direction: column;
        padding-right: 30vw;
        padding-left: 30vw;
    }

    .im_close_w {
        display: flex;
        justify-self: flex-end;
        width: 30px;
        height: 30px;
        margin-right: -6vw;
        margin-top: 0;
        cursor: pointer;
    }

    .im_close_w {
        filter: brightness(0%) invert(100%);
        -webkit-filter: brightness(0%) invert(100%);
    }

    .small-share-img {
        height: 5vw;
        object-fit: contain;
    }

    .div_nome_l {
        margin-top: 5vw;
        width: 100%;
    }

    .tx_nome_before_w, .tx_nome_w {
        display: flex;
        width: 100%;
        font-size: 25pt;
        /*color: gray;*/
    }

    .tx_nome_w {
        color: white;
        font-size: 3vh;
    }

    .tx_nome_before_w {
        color: white;
        font-family: 'Humanst521BT';
        font-size: 3vh;
    }

    .hr_w {
        width: 100%;
        height: 2px;
        margin-top: 5px;
        background: gray;
    }

    .hr_w {
        background-color: white;
    }

    .error_msg {
        font-family: 'Humanst521BT';
        color: red;
        font-size: 2.5vh;
    }

    .div_check {
        display: flex;
        width: 100%;
        margin-top: 0;
        align-items: center;
    }

    .div_check_in {
        display: flex;
        border-width: 2px;
        border-style: solid;
        border-color: white;
        width: 15px !important;
        height: 15px !important;
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
        cursor: pointer;
    }

    .tx_checkbox {
        color: white;
        font-weight: bold;
        margin-top: -4px;
    }

    .tx_check {
        color: white;
        font-style: normal;
        text-align: center;
        display: flex;

        font-weight: normal;
        display: flex;
        font-size: 9pt;
        font-size: 2.5vh;
        margin-left: 1.5vw;

        justify-items: flex-end;
        align-content: flex-end;
        alignment-baseline: bottom;
    }

    .div_botao_login {
        border-style: solid;
        border-color: white;
        border-width: 1px;
        width: 15vw;
        height: 5vh;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        /*background: white;*/

        color: white;
    }

    .tx_title_tabua {
        font-size: 6vh;
    }

    .div_expedicao, .div_expedicao_in {
        /*margin: 2vh;*/
        background-color: white;
        background-size: cover;
        /*background-color: yellow;*/
        width: 100%;
        color: var(--bg-blue);
        font-size: 2vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /*padding-right: 2.5vw;*/
        /*padding-left: 2.5vw;*/
        padding-top: 2vw;
        padding-bottom: 0px;
        margin-bottom: 0px;
        /*background-color: #002b51;*/
    }

    .div_expedicao_in {
        /*background-color: red;*/
        width: 100%;
        padding-top: unset;
        /*height: 50%;*/
        /*max-height: 50%;*/
        flex-direction: row;
        justify-content: space-between;
    }

    .crop_tabua {
        display: flex;
        width: 30%;
        height: 50%;
        max-height: 50%;
        overflow-y: hidden;
    }
    .im_tabua {
        display: flex;
        background-image: url("/static/imgs/advicep_horizontal.png");
        background-repeat: repeat-y;
        width: 100%;
        height: 50%;
        object-fit: contain;
        overflow-y: hidden;
        object-position: 0 -20%;
    }

    .ct_arrow {
        width: 50%;
        /*background-color: red;*/
        display: flex;
        justify-content: space-between;
    }

    .bt_arrow1, .bt_arrow2 {
        width: 10vh;
        object-fit: contain;
        padding-left: 3vh;
        padding-right: 3vh;
    }
    .bt_arrow2 {
        transform: rotate(180deg);
    }
    .bt_arrow1:hover, .bt_arrow2:hover {
        filter: brightness(0.5);
    }
    .bt_arrow1:active, .bt_arrow2:active {
        filter: brightness(1.3);
    }
</style>



// WEBPACK FOOTER //
// src/components/dTabua.vue